module.exports = __webpack_public_path__ + "img/hb4.66625b64.jpg";